var map = {
	"app/modules/customer/customer.module": [
		"./src/app/modules/customer/customer.module.ts",
		"customer.module",
		"common"
	],
	"app/pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"home.module"
	],
	"app/pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"common",
		"login.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main